// get data for current users room and current area id
// https://mccglc.atlassian.net/l/c/hXKp0WFb for DOCS

const state = {
  // whereabouts --------------------------------------------------
  currentWhereabouts: {}, //users current joined room and area (even if not on that page)
  // current users space ------------------------------------------
  currentUsersRoom: {},
};

const getters = {
  // whereabouts ----------------------------------------------
  //get data for users current joined meeting - see currentSpace.js for more getters
  getCurrentWhereaboutsData: (state) => {
    return state.currentWhereabouts
  },
  // CURRENT USERS ROOM ---------------------------------------------------
  getCurrentUsersAreaId: (state,getters) => {
    return getters.getCurrentWhereaboutsData?.currentAreaId || ''
  },
  getCurrentUsersRoomId: (state,getters) => {
    return getters.getCurrentWhereaboutsData?.currentSpaceId || ''
  },
  getCurrentUsersRoom: (state) => {
    return state.currentUsersRoom || {}
  },
  // get name for users current joined meeting
  getCurrentUsersRoomName: (state,getters) => {
    return getters.getCurrentUsersRoom?.name || ''
  },
  // get name for users current joined meeting
  getCurrentUsersRoomType: (state,getters) => {
    return getters.getCurrentUsersRoom?.spaceType || ''
  },
  getCurrentUsersRoomConferenceType: (state,getters) => {
    return getters.getCurrentUsersRoom?.conferenceType || ''
  },
  getCurrentUsersRoomLocationLifestyle: (state,getters) => {
    return getters.getCurrentUsersRoom?.location?.locationLifestyle || getters.getCurrentUsersRoom?.locationLifestyle
  },
  getCurrentUsersRoomLink: (state,getters) => {
    return getters.getCurrentUsersRoom?.joinLink || ''
  },
  getCurrentUsersRoomHost: (state,getters) => {
    return getters.getCurrentUsersRoom?.hostEmail || ''
  },

  // check if the users joined meeting is the hub
  getIfCurrentUsersRoomIsHub: (state,getters) => {
    // as far as I can tell, this should be true if the user is not in a meeting
    // unfortunately, it breaks if a user goes to the homepage mid-meeting
    // not a huge problem, since that won't be possible in the new nav
    // but probably worth investigating at some point - could maybe cause other bugs
    return !getters.getCurrentWhereaboutsData?.inSpaceActivity
  },
  // check if a room page (by id) is the users joined meeting
  getIfIdIsCurrentUsersRoom: (state,getters) => (id) => {
    return getters.getCurrentUsersRoomId === id
  },
  //check if current page is users joined meeting
  getIfOnCurrentUsersRoomPage: (state,getters) => {
    return getters.getCurrentUsersRoomId === getters.getCurrentLocationId
  },
  getIfOnJoinedRoomPage: (state,getters) => {
    return getters.getIfOnCurrentUsersRoomPage && !getters.getIfCurrentUsersRoomIsHub
  },
};

const mutations = {
  // whereabouts ----------------------------------------------
  setCurrentWhereabouts(state, data) {
    state.currentWhereabouts = data
  },

  // current users room ---------------------------------------
  setCurrentUsersRoom(state, data) {
    state.currentUsersRoom = data
  },
};

const actions = {
  // whereabouts ----------------------------------------------
  async updateWhereabouts({commit}, data) {
    commit('setCurrentWhereabouts', data)
  },

  // current users room ---------------------------------------
  async updateCurrentUsersRoom({getters,commit},data) {
    let currentWhereabouts = getters.getCurrentWhereaboutsData
    if(!currentWhereabouts?.currentAreaId) return

    let locationData = data.location ? data.location : data

    let currentUsersRoomId = getters.getCurrentUsersRoomId
    if(data.id === currentUsersRoomId) {
      if(data.joinLink !== undefined) return commit('setCurrentUsersRoom', data);
      else return;
    }
    let updatedData = {}

    if(data.locationType === 'space') {
      updatedData = data;
    } else if(locationData.locationType === 'space') {
      updatedData = locationData
    } else if (locationData.locationType === 'area') {
      updatedData = getters.getRoomData(currentUsersRoomId)
    }
    //if area update, getRoomData + merge
    //if space update and current page - merge
    if(updatedData) commit('setCurrentUsersRoom', updatedData)
  },
  // set current users room to empty (only for root area/ when on home page)
  async clearCurrentUsersRoom({commit}) {
    commit('setCurrentUsersRoom', {})
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
